function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import { customElement as c } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as u } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/property.js";
import { state as p } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/state.js";
import { NgcInputText as v } from "../input-text/input-text.gator.js";
import { KEY_CONSTANTS as h } from "../../../../consts/key-constants.js";
var m = Object.defineProperty,
  _ = Object.getOwnPropertyDescriptor,
  d = Object.getPrototypeOf,
  f = Reflect.get,
  l = function l(t, e, s, a) {
    for (var r = a > 1 ? void 0 : a ? _(e, s) : e, n = t.length - 1, o; n >= 0; n--) (o = t[n]) && (r = (a ? o(e, s, r) : o(r)) || r);
    return a && r && m(e, s, r), r;
  },
  g = function g(t, e, s) {
    return f(d(t), s, e);
  };
var i = /*#__PURE__*/function (_v) {
  function i() {
    var _this;
    _classCallCheck(this, i);
    _this = _callSuper(this, i, arguments), _this.maskPreset = null, _this.maskPattern = "", _this.acceptedCharType = "numeric", _this.variableMaxLength = 10, _this.value = "", _this._value = "", _this._inputFocused = !1, _this._cursorPosition = null;
    return _this;
  }
  _inherits(i, _v);
  return _createClass(i, [{
    key: "updated",
    value: function updated(t) {
      var _this$inputRef$value, _this$inputRef$value2;
      _superPropGet(i, "updated", this, 3)([t]), t.has("value") && (this._value = this.formatValue(this.value), (_this$inputRef$value = this.inputRef.value) !== null && _this$inputRef$value !== void 0 && _this$inputRef$value.setSelectionRange(this._cursorPosition, this._cursorPosition)), t.has("errorText") && !this.errorText && this.validateChars(this.value), t.get("_cursorPosition") && (_this$inputRef$value2 = this.inputRef.value) !== null && _this$inputRef$value2 !== void 0 && _this$inputRef$value2.setSelectionRange(this._cursorPosition, this._cursorPosition), t.has("maskPreset") && (this._placeholder = this.placeholder ? this.placeholder : this._maskPattern.split("").map(function (e, s) {
        return e === "#" ? ((s + 1) % 10).toString() : e;
      }).join(""), this.maskPreset === "variable" ? this._maxLength = this.variableMaxLength : this._maxLength = this._maskPattern.length, this._value = this.formatValue(this.value));
    }
  }, {
    key: "handleInputEvent",
    value: function handleInputEvent(t) {
      var _e$selectionStart;
      t.preventDefault(), t.stopPropagation();
      var e = t.target,
        s = (_e$selectionStart = e.selectionStart) !== null && _e$selectionStart !== void 0 ? _e$selectionStart : 0,
        a = this.formatValue(e.value),
        r = this._value.length < e.value.length,
        n = !!this.displayedErrorText,
        o = new CustomEvent("input", {
          bubbles: !0,
          composed: !0,
          detail: {
            formatted: a,
            raw: n ? a : a.replaceAll("-", "")
          }
        });
      r && e.value[s] !== "-" && a[s - 1] === "-" ? this._cursorPosition = s + 1 : this._cursorPosition = s, this._value = a, this.dispatchEvent(o);
    }
  }, {
    key: "handleKeyup",
    value: function handleKeyup(t) {
      if (t.key === h.LEFT || t.key === h.RIGHT) {
        var _e$selectionStart2;
        var e = t.target;
        this._cursorPosition = (_e$selectionStart2 = e.selectionStart) !== null && _e$selectionStart2 !== void 0 ? _e$selectionStart2 : 0;
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(t) {
      var _e$selectionStart3;
      var e = t.target;
      this._cursorPosition = (_e$selectionStart3 = e.selectionStart) !== null && _e$selectionStart3 !== void 0 ? _e$selectionStart3 : 0;
    }
  }, {
    key: "handleInputFocusIn",
    value: function handleInputFocusIn() {
      _superPropGet(i, "handleInputFocusIn", this, 3)([]), this._inputFocused = !0, this._value = this.formatValue(this.value);
    }
  }, {
    key: "handleInputFocusOut",
    value: function handleInputFocusOut() {
      _superPropGet(i, "handleInputFocusOut", this, 3)([]), this._inputFocused = !1, this._value = this.formatValue(this._value);
    }
  }, {
    key: "_maskPattern",
    get: function get() {
      switch (this.maskPreset) {
        case "ssn":
          return "XXX-XX-####";
        case "ein":
          return "XX-XXX####";
        case "variable":
          return this.variableMaskPattern();
        default:
          return this.maskPattern;
      }
    }
  }, {
    key: "variableMaskPattern",
    value: function variableMaskPattern() {
      var t = this._value.length + 1;
      return t <= 5 ? "#".repeat(t) : "X".repeat(t - 5) + "#".repeat(5);
    }
  }, {
    key: "validateChars",
    value: function validateChars(t) {
      var e = {
        numeric: {
          regex: /^[0-9]*$/,
          errText: "numbers"
        },
        alpha: {
          regex: /^[a-zA-Z]*$/,
          errText: "letters"
        },
        alphanumeric: {
          regex: /^[a-zA-Z0-9]*$/,
          errText: "letters, numbers,"
        }
      };
      return e[this.acceptedCharType].regex.test(t.replaceAll("-", "")) ? (this._internalValidationError = "", !0) : (this._internalValidationError = "Invalid input. Use only ".concat(e[this.acceptedCharType].errText, " and dashes in this field."), !1);
    }
  }, {
    key: "formatValue",
    value: function formatValue(t) {
      if (!this.validateChars(t)) return t;
      var e = t.replaceAll(/[^a-zA-Z0-9]/g, "").substring(0, this._maskPattern.length);
      var s = "",
        a = 0;
      for (var r = 0; r < this._maskPattern.length && a !== e.length; ++r) {
        var n = e[a],
          o = this._maskPattern[r];
        switch (o) {
          case "X":
            {
              this._inputFocused ? s += n : s += "X", a++;
              break;
            }
          case "#":
            {
              s += n, a++;
              break;
            }
          default:
            s += o;
        }
      }
      return s;
    }
  }]);
}(v);
i.styles = _toConsumableArray(g(i, i, "styles"));
l([u({
  attribute: "mask-preset"
})], i.prototype, "maskPreset", 2);
l([u({
  attribute: "mask-pattern"
})], i.prototype, "maskPattern", 2);
l([u({
  attribute: "accepted-char-type"
})], i.prototype, "acceptedCharType", 2);
l([u({
  attribute: "variable-max-length"
})], i.prototype, "variableMaxLength", 2);
l([p()], i.prototype, "_inputFocused", 2);
l([p()], i.prototype, "_cursorPosition", 2);
i = l([c("ngc-input-masked")], i);
export { i as NgcInputMasked };